$(document).ready(function() {

    $('.menu').click(function(){
        $('.side-menu-bar').toggleClass('active');
        // window.location.hash = '#open';
    });

    // window.onhashchange = function () {
    //     if (location.hash != '#open') {
    //         $('.side-menu-bar, #wrap, html').removeClass('active');
    //     }
    // };

    $('.side-close').click(function() {
        $('.side-menu-bar').removeClass('active');
    });
    
    // $('.more-load:gt(4)').hide().last().after(
    //     $('.btn-more').click(function() {
    //         var a = this;
    //         $('.more-load:not(:visible):lt(3)').fadeIn(function() {
    //             if($('.more-load:not(:visible)').lenght == 0) $(a).remove();
    //         }); return false;
           
    //     }) 
    // );

    // $('.more-load').slice(0,3).show();
    // $('.btn-more').on('click', function(e) {
    //     e.preventDefault();
    //     $('.more-load:hidden').slice(0,3).fadeIn();
    //     if($('.more-load:hidden').length == 0 ) {
    //         $('.btn-more').text('').addClass('no-more');
    //     }
    // });

    // $('html, body').css({'overflow': 'hidden', 'height': '100%'});
    // $('.popup-wrap').on('scroll touchmove mousewheel', function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     return false;
    // });
    // $('html, body').css({'overflow': 'auto', 'height': '100%'});
    // $('.popup-wrap').off('scroll touchmove mousewheel');

    // /* 카페 상세 페이지 좌석 종류 탭*/
    // $('.tab-header > ul > li').click(function() {
    //     var activeTab = $(this).attr('data-tab');
    //     $('.tab-header > ul > li').removeClass('active');
    //     $('.tab-body > ul > li').removeClass('active');

    //     $(this).addClass('active');
    //     $('#' + activeTab).addClass('active');

    // });
})


// WEBPACK FOOTER //
// ./src/assets/js/index.js